import React from "react";

const Divider = () => {
  return (
    <div className="lg divider">
      <span className="circle"></span>
      <span className="line left"></span>
      <span className="line vertical left"></span>
      <h2>OR</h2>
      <span className="line vertical"></span>
      <span className="line right"></span>
      <span className="circle"></span>
    </div>
  );
};

export default Divider;
